import { FormControlLabel } from '@material-ui/core';
import React, { FC, memo } from 'react';
import { CheckboxState, MuiCheckbox } from './mui-checkbox';

const noop = () => undefined;

interface Props {
  label: string;
  checked?: boolean;
  state?: CheckboxState;
  color?: 'primary' | 'secondary' | 'default';
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
}

export const MuiCheckboxWithLabel: FC<Props> = memo(
  ({
    label,
    checked,
    state,
    disabled,
    color,
    onChange = noop
  }: Readonly<Props>) => (
    <FormControlLabel
      label={label}
      control={
        <MuiCheckbox
          checked={checked}
          state={state}
          color={color}
          disabled={disabled}
          onChange={onChange}
        />
      }
    />
  )
);

MuiCheckboxWithLabel.displayName = 'MuiCheckboxWithLabel';
